import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

import { Link } from 'react-router-dom'

import { numberWithCommas } from 'utils/priceConvert'
import { truncateText } from 'utils/helperText'

const ProductCard = (props) => {
  return (
    <Link to={`/shop/${props.slug}`} className="product-card">
      <div className="cover-image">
        <img src={props.img01} alt={props.img01} />
        <div className="tag">
          <p className="text">New arrival</p>
        </div>
      </div>
      <div className="content">
        <span className="title">{truncateText(props.name, 20)}</span>
        <span className="price">${numberWithCommas(props.price)}</span>
      </div>
    </Link>
  )
}

ProductCard.propTypes = {
  img01: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired
}

export default ProductCard
